/* unplugin-vue-components disabled */import script from "./DraggableWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./DraggableWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./DraggableWrapper.vue?vue&type=style&index=0&id=183db3e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-183db3e2"]])

export default __exports__